export enum NotificationEventType {
  CheckRegisterReportCreated = 'check_register_report_created',
  GroupScheduleError = 'group_schedule_error',
  AllPaymentFilesNotComplete = 'all_payment_files_not_complete',
  ConsolidatedSingleErrors = 'consolidated_single_errors',
  GroupExpirationAlert = 'group_expiration_alert',
  NetworkCheckRegisterReportCreated = 'network_check_register_report_created',
  NomiStatusReportReceived = 'nomi_status_report_received',

  // TODO: zabelin left it for backward compatibility, remove after approval
  LuminxSingleProvider = 'luminx_single_provider',
  ZelisSinglePaymentType = 'zelis_single_payment_type'
}

export const mapper: Record<NotificationEventType, string> = {
  [NotificationEventType.CheckRegisterReportCreated]: 'Check Register report created',
  [NotificationEventType.GroupScheduleError]: 'Group schedule error',
  [NotificationEventType.AllPaymentFilesNotComplete]: 'All payment files not complete',
  [NotificationEventType.ConsolidatedSingleErrors]: 'Single Provider/Payment Type',
  [NotificationEventType.GroupExpirationAlert]: 'Group expiration alert',
  [NotificationEventType.NetworkCheckRegisterReportCreated]:
    'Network Check Register report created',
  [NotificationEventType.NomiStatusReportReceived]: 'NOMI Status Report Received',

  // TODO: zabelin left it for backward compatibility, remove after approval
  [NotificationEventType.LuminxSingleProvider]: 'LuminX Single Provider',
  [NotificationEventType.ZelisSinglePaymentType]: 'Zelis Single Payment Type'
}
